import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showMaintenanceForm(event) {
    document.getElementById('task-type-chooser').classList.add('hidden');
    document.getElementById('maintenance-task-form').classList.remove('hidden');
  }
}
